import React, { useEffect, useState } from 'react';
import { Slider } from 'primereact/slider';
import './52WeekRange.scss'
import { Col, Container, Row } from 'react-bootstrap';
import NumberFormatter from '../../formatters/NumberFormatter';

const Week52Range = (props) => {
    let numberFormatter = new NumberFormatter();
    const [minValue, setMinValue] = useState(0);
    const [maxValue, setMaxValue] = useState(0);
    const [lastValue, setLastValue] = useState(0);

    useEffect(() => {
        if (props && props.data && props.data.range52w) {
            setMinValue(props.data.range52w.low);
            setMaxValue(props.data.range52w.high);
            setLastValue(props.data.range52w.last);
        }
    }, [props]);

    const onChange = (e) => {
        setLastValue(e.value);
    };

    return (
        <div className="week52Range">
            <Container>
                <Row className="week-values">
                    <Col md='6' className='float-left text-align-left p-0'>
                        {numberFormatter.Double(minValue, 2)}
                    </Col>
                    <Col md='6' className='float-right text-align-right p-0'>
                        {numberFormatter.Double(maxValue, 2)}
                    </Col>
                </Row>
            </Container>

            <Container>
                <Row>
                    <Col className='p-0'>
                        <div className="card flex justify-content-center p-0">
                            <Slider
                                max={maxValue}
                                min={minValue}
                                value={lastValue}
                                className="w-14rem"
                                disabled
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Week52Range;